import { CookieLibrary } from '@/core/apis/browser_storage_api/cookie_lib/cookie_lib';

export const TiktokCookieLogic = {
  cookiesToUpdate: ['_ttp'],
  getTtpCookie: () => CookieLibrary.get('_ttp'),
  updateCookies: (
    cookies: Record<string, string>,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _iqpars: Record<string, string[]>,
  ): Record<string, string> => {
    const newCookies: Record<string, string> = { ...cookies };

    if (TiktokCookieLogic.cookiesToUpdate?.includes('_ttp')) {
      const ttpCookie = TiktokCookieLogic.getTtpCookie();
      if (ttpCookie) {
        newCookies['_ttp'] = ttpCookie;
      }
    }

    return newCookies;
  },
};
